import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2, Camera } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function Profile() {
  const { user, setAuthUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || '',
    phone: user?.phone || '',
    date_of_birth: user?.date_of_birth || '',
    country_of_residence: user?.country_of_residence || '',
    nationality: user?.nationality || 'Congolaise',
  });
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    try {
      const r = await api.put('/users/profile', form);
      setAuthUser(r.data);
      toast.success('Profil mis a jour');
    } catch {
      toast.error('Erreur lors de la mise a jour');
    } finally {
      setLoading(false);
    }
  };

  const handlePhoto = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      const r = await api.post('/users/photo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setAuthUser({ ...user, photo_url: r.data.url });
      toast.success('Photo mise a jour');
    } catch {
      toast.error('Erreur upload photo');
    }
  };

  return (
    <div className="max-w-lg mx-auto space-y-6 animate-fade-in" data-testid="profile-page">
      <h1 className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>Mon Profil</h1>

      <Card className="border">
        <CardContent className="p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="relative">
              <div className="w-16 h-16 rounded-full bg-[#007FFF] flex items-center justify-center text-white text-2xl font-bold overflow-hidden">
                {user?.photo_url ? (
                  <img src={`${process.env.REACT_APP_BACKEND_URL}${user.photo_url}`} alt="Photo" className="w-full h-full object-cover" />
                ) : user?.picture ? (
                  <img src={user.picture} alt="Photo" className="w-full h-full object-cover" />
                ) : (
                  (user?.name || 'U').charAt(0).toUpperCase()
                )}
              </div>
              <label className="absolute -bottom-1 -right-1 w-7 h-7 bg-white border rounded-full flex items-center justify-center cursor-pointer hover:bg-muted">
                <Camera className="w-3.5 h-3.5" />
                <input type="file" className="hidden" accept="image/*" onChange={handlePhoto} />
              </label>
            </div>
            <div>
              <p className="font-semibold">{user?.name}</p>
              <p className="text-sm text-muted-foreground">{user?.email}</p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Nom complet</Label>
              <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} data-testid="profile-name" />
            </div>
            <div className="space-y-2">
              <Label>Telephone</Label>
              <Input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} data-testid="profile-phone" />
            </div>
            <div className="space-y-2">
              <Label>Date de naissance</Label>
              <Input type="date" value={form.date_of_birth} onChange={e => setForm({...form, date_of_birth: e.target.value})} data-testid="profile-dob" />
            </div>
            <div className="space-y-2">
              <Label>Pays de residence</Label>
              <Input value={form.country_of_residence} onChange={e => setForm({...form, country_of_residence: e.target.value})} data-testid="profile-country" />
            </div>
            <Button className="w-full bg-[#007FFF] hover:bg-[#0066CC]" onClick={handleSave} disabled={loading} data-testid="profile-save-btn">
              {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
              Sauvegarder
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
